import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ICommunicationState } from './communication';

const stateSelector =
  createFeatureSelector<ICommunicationState>('communication');
export const selectResponseRetrieveRecipients = createSelector(
  stateSelector,
  (state: ICommunicationState) => state.responseRecipients
);

export const selectResponseListaReteTerza = createSelector(
  stateSelector,
  (state: ICommunicationState) => state.responseReteTerzaList
);

export const selectResponseVerifyRecipientsList = createSelector(
  stateSelector,
  (state: ICommunicationState) => state.responseVerifyRecipientsList
);

export const selectResponseSaveRecipientsList = createSelector(
  stateSelector,
  (state: ICommunicationState) => state.responseSaveRecipientsList
);
export const selectBoardList = createSelector(
  stateSelector,
  (state: ICommunicationState) => state.responseBoardList
);

export const selectReportBacheca = createSelector(
  stateSelector,
  (state: ICommunicationState) => state.responseReportBacheca
);

export const selectResponseRichiediExport = createSelector(
  stateSelector,
  (state: ICommunicationState) => state.responseRequestExport
);

export const selectResponseRetrieveHeaderDetail = createSelector(
  stateSelector,
  (state: ICommunicationState) => state.responseRetrieveHeaderDetail
);

export const selectResponseSaveHeaderDetail = createSelector(
  stateSelector,
  (state: ICommunicationState) => state.responseSaveHeaderDetail
);

export const selectResponeMessaggiBacheca = createSelector(
  stateSelector,
  (state: ICommunicationState) => state.responseMessaggiBacheca
);

export const selectResponeDestinatariBacheca = createSelector(
  stateSelector,
  (state: ICommunicationState) => state.responseDestinatariBacheca
);

export const selectResponeSaveDetailMessageBacheca = createSelector(
  stateSelector,
  (state: ICommunicationState) => state.responseSaveDetailMessageBacheca
);

export const selectResponeInvioDetailMessageBacheca = createSelector(
  stateSelector,
  (state: ICommunicationState) => state.responseInvioDetailMessageBacheca
);

export const selectResponseRetrieveIdRecipients = createSelector(
  stateSelector,
  (state: ICommunicationState) => state.responseRetrieveIdRecipients
);

export const selectResponseRetrieveHeaderList = createSelector(
  stateSelector,
  (state: ICommunicationState) => state.responseRetrieveHeaderList
);

export const selectResponseHeaderEditState = createSelector(
  stateSelector,
  (state: ICommunicationState) => state.responseEditHeaderState
);

export const selectResponseEditSaveHeaderDetail = createSelector(
  stateSelector,
  (state: ICommunicationState) => state.responseEditSaveHeaderDetail
);

export const selectResponseDeleteElBacheca = createSelector(
  stateSelector,
  (state: ICommunicationState) => state.responseDeleteElBacheca
);

export const selectResponseEditRecipientsList = createSelector(
  stateSelector,
  (state: ICommunicationState) => state.responseEditRecipientsList
);
